// NIGHT-DIRECTSTAFF-2026-10-25c §4: "Problem reports" on the Facilities tab -- what facility contacts sent with the portal's "Report a
// problem" (facility portal v1.7: an event and a staff alert, "Facility portal problem report · <page>: <text> (from <email>)").
// Read only here; the alert itself is closed from Needs a human as any other. Nothing shows before v1.7 sends one.
import React, { useState } from 'react';

const when = (iso) => (iso ? new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '');

/** rows: lib/facilityPortal.js problemReports(notifications) */
export default function FacilityProblems({ rows = [] }) {
  const [all, setAll] = useState(false);
  if (!rows.length) return null;
  const open = rows.filter((r) => r.open);
  const shown = all ? rows : open.length ? open : rows.slice(0, 3);
  return (
    <section data-testid="facility-problems" aria-labelledby="facility-problems-title" className="card" style={{ padding: 14, marginBottom: 12, minWidth: 0 }}>
      <h3 id="facility-problems-title" style={{ fontSize: 15, fontWeight: 800, margin: '0 0 6px', color: '#9a3412' }}>Problem reports <span style={{ fontWeight: 600 }}>({open.length} open of {rows.length})</span></h3>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {shown.map((r) => (
          <li key={r.id} data-testid={`facility-problem-${String(r.id).slice(0, 8)}`} style={{ borderTop: '1px solid #f1f5f9', padding: '6px 0', fontSize: 13, overflowWrap: 'anywhere' }}>
            <div style={{ color: '#475569', fontSize: 12 }}>{when(r.at)} · on {r.page}{r.from ? ` · from ${r.from}` : ''}{r.open ? '' : ' · closed'}</div>
            <div style={{ color: '#0f172a' }}>{r.text}</div>
          </li>))}
      </ul>
      {rows.length > shown.length && <button className="nb" data-testid="facility-problems-all" onClick={() => setAll(true)}
        style={{ marginTop: 6, background: '#f1f5f9', color: '#334155', borderRadius: 8, padding: '0 14px', minHeight: 44, fontSize: 13, fontWeight: 700, border: 0 }}>Show all {rows.length}</button>}
    </section>
  );
}
